import type { AnalyticsSummary } from "../types/analytics";

interface StatCardDef {
  labelKey: string;
  summaryField: keyof AnalyticsSummary;
  isCurrency: boolean;
}

const STAT_CARD_DEFS: StatCardDef[] = [
  { labelKey: "analytics:totalInvoices", summaryField: "totalInvoices", isCurrency: false },
  { labelKey: "analytics:totalPaid", summaryField: "totalPaid", isCurrency: true },
  { labelKey: "analytics:pending", summaryField: "pendingCount", isCurrency: false },
  { labelKey: "analytics:avgMonthly", summaryField: "avgMonthly", isCurrency: true },
];

interface StatCardValue {
  labelKey: string;
  value: string;
  raw: number;
}

const buildStatCardValues = (summary: AnalyticsSummary, formatCurrency: (amount: number) => string): StatCardValue[] =>
  STAT_CARD_DEFS.map((def) => {
    const rawValue = summary[def.summaryField];
    const value = def.isCurrency ? formatCurrency(rawValue as number) : String(rawValue);
    return { labelKey: def.labelKey, value, raw: rawValue as number };
  });

const getGreetingKey = (hour: number): "morning" | "afternoon" | "evening" => {
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
};

export { buildStatCardValues, getGreetingKey, STAT_CARD_DEFS };

export { type StatCardDef, type StatCardValue };
